var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58346 9.03878C6.34015 12.8649 9.46599 15.9068 13.3522 17.5559L13.9752 17.8335C15.4004 18.4685 17.0759 17.986 17.9452 16.6903L18.7593 15.4769C19.024 15.0824 18.9434 14.5511 18.5736 14.2528L15.8128 12.0255C15.4072 11.6983 14.8109 11.7745 14.5007 12.1931L13.6466 13.3456C11.4551 12.2645 9.67576 10.4852 8.5947 8.29367L9.74718 7.43959C10.1658 7.12937 10.242 6.53307 9.91483 6.12755L7.68745 3.3666C7.38922 2.99692 6.85801 2.91629 6.46351 3.18081L5.24174 4.00003C3.93792 4.87427 3.45815 6.56354 4.10783 7.99258L4.58274 9.03723L4.58346 9.03878Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.491552e8e9828d33f4264daf29cb81df.svg";
export { ForwardRef as ReactComponent };